function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { createRef, useEffect, useMemo } from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { addVariant } from '../../../modules/variant-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpInputAdornmentContainerStyle, OwnUpInputAdornmentDecoratorStyle, OwnUpInputAdornmentLabelStyle } from './style';
/**
 *  Input adornment component properties.
 */

var OwnUpInputAdornmentContainerImpl = createOwnUpComponent('div', OwnUpInputAdornmentContainerStyle);
var OwnUpInputAdornmentLabel = createOwnUpComponent('label', OwnUpInputAdornmentLabelStyle);
var OwnUpInputAdornmentDecorator = createOwnUpComponent('span', OwnUpInputAdornmentDecoratorStyle);

var isDefined = function isDefined(value) {
  return value !== null && value !== undefined && (typeof value !== 'string' ? true : value !== '');
};
/**
 * Adorns the input to be more beautiful and pleaseing
 *
 * @param props - Seet {@link OwnUpNumberInputProperties}
 */


export var AdornOwnUpInput = function AdornOwnUpInput(_ref) {
  var className = _ref.className,
      placeholder = _ref.placeholder,
      value = _ref.value,
      error = _ref.error,
      name = _ref.name,
      decorator = _ref.decorator,
      topLevelOnFocus = _ref.onFocus,
      topLevelonBlur = _ref.onBlur,
      input = _ref.input,
      inputProps = _ref.inputProps,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["className", "placeholder", "value", "error", "name", "decorator", "onFocus", "onBlur", "input", "inputProps", "variant"]);

  var containerRef = /*#__PURE__*/createRef();
  var shouldShrink = isDefined(value) || isDefined(placeholder);

  var _React$useState = React.useState(shouldShrink),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isShrunk = _React$useState2[0],
      setIsShrunk = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isFocused = _React$useState4[0],
      setIsFocused = _React$useState4[1]; // Class names


  var labelBuiltClass = useMemo(function () {
    return buildClassNames("ou-input-adornment-label".concat(isShrunk ? '-shrink' : ''), className);
  }, [className, isShrunk]);
  var containerBuiltClass = useMemo(function () {
    return buildClassNames("ou-input-adornment-container".concat(isFocused ? '-focused' : ''), className);
  }, [className, isFocused]);
  var decoratorBuiltClass = useMemo(function () {
    return buildClassNames('ou-input-adornment-decorator', className);
  }, [className]);
  var inputComponent = input(_objectSpread(_objectSpread({
    name: name,
    className: className,
    placeholder: placeholder,
    value: value,
    style: _objectSpread(_objectSpread({
      width: decorator ? 'calc(100% - 46px)' : 'calc(100% - 20px)'
    }, inputProps && inputProps.style ? inputProps.style : {}), props.style || {})
  }, inputProps ? inputProps : {}), props));
  /**
   * Add additional variants as needed.
   */

  var compiledVariants = useMemo(function () {
    var variantSet = variant;

    if (isFocused) {
      variantSet = addVariant(variantSet, 'focused');
    }

    if (error) {
      variantSet = addVariant(variantSet, 'error');
    }

    return variantSet;
  }, [error, isFocused, variant]);
  useEffect(function () {
    setIsShrunk(shouldShrink);
  }, [setIsShrunk, shouldShrink]);
  return /*#__PURE__*/React.createElement(OwnUpInputAdornmentContainerImpl, {
    ref: containerRef,
    className: containerBuiltClass,
    variant: compiledVariants,
    onFocus: function onFocus(focused) {
      setIsShrunk(true);
      setIsFocused(true);

      if (topLevelOnFocus !== undefined) {
        topLevelOnFocus(focused);
      }
    },
    onBlur: function onBlur(focused) {
      setIsShrunk(shouldShrink);
      setIsFocused(false);

      if (topLevelonBlur !== undefined) {
        topLevelonBlur(focused);
      }
    },
    onClick: function onClick(_ref2) {
      var target = _ref2.target;
      var input = target.querySelector('input');

      if (input) {
        input.focus();
      } else {
        var button = target.querySelector('button');

        if (button) {
          button.click();
        }
      }
    }
  }, decorator ? /*#__PURE__*/React.createElement(OwnUpInputAdornmentDecorator, {
    onClick: function onClick() {
      return containerRef.current.click();
    },
    className: decoratorBuiltClass
  }, decorator) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(OwnUpInputAdornmentLabel, {
    className: labelBuiltClass,
    variant: [decorator ? 'decorated' : undefined, isShrunk ? 'shrink' : undefined],
    onClick: function onClick() {
      return containerRef.current.click();
    }
  }, name), inputComponent);
};